import { useEffect, useRef, useState } from 'react';
import { enableReminders, reminderStatus, sendTestNotification, type ReminderStatus } from '../reminders';
import { trackReminder } from '../telemetry';

// One-tap opt-in to notifications, for moments where one would obviously help
// ("tell me when they play", "tell me when my topic launches"). Hidden when
// this device can't do push, or it's already on. One subscription covers
// streak reminders, duel alerts and topic launches.
export function AlertsOptIn({ prompt, where, doneText = "🔔 You'll get a ping" }: { prompt: string; where: string; doneText?: string }) {
  const [status, setStatus] = useState<ReminderStatus | 'loading' | 'working' | 'just-on'>('loading');
  const shown = useRef(false);

  useEffect(() => {
    reminderStatus().then(setStatus).catch(() => setStatus('unsupported'));
  }, []);

  useEffect(() => {
    if (status === 'off' && !shown.current) {
      shown.current = true;
      trackReminder('prompt_shown', where);
    }
  }, [status, where]);

  if (status === 'just-on') {
    return <p style={{ color: '#39FF88', fontWeight: 700, fontSize: '0.9rem', padding: '0.5rem' }}>{doneText}</p>;
  }
  if (status === 'denied') {
    return <p style={{ color: '#888', fontSize: '0.8rem' }}>Notifications are blocked for this site in your browser settings.</p>;
  }
  if (status !== 'off' && status !== 'working') return null;

  const enable = async () => {
    setStatus('working');
    try {
      const next = await enableReminders();
      if (next === 'on') {
        trackReminder('enabled', where);
        setStatus('just-on');
        sendTestNotification('duel').catch(() => {});
      } else {
        trackReminder('denied', where);
        setStatus(next);
      }
    } catch {
      setStatus('off');
    }
  };

  return (
    <button className="btn btn-ghost" onClick={enable} disabled={status === 'working'} style={{ padding: '0.75rem', border: '1px dashed #3A3658' }}>
      {status === 'working' ? 'Turning on…' : prompt}
    </button>
  );
}
